import { globby } from 'globby';
import type { WixConfigSchema } from './files/wix.config.js';

export async function importCliAstro(
  config: WixConfigSchema,
  projectFolder: string
) {
  if (Object.hasOwn(config, 'appId')) {
    const astroExists = await hasAstroConfigurationFile(projectFolder);
    if (astroExists) {
      return import('@wix/cli-astro-commands');
    }
  }
  return null;
}

// https://docs.astro.build/en/basics/project-structure/#astroconfigmjs
async function hasAstroConfigurationFile(projectFolder: string) {
  const configFilesFound = await globby('astro.config.{js,cjs,mjs,ts}', {
    cwd: projectFolder,
    onlyFiles: true,
  });
  return configFilesFound.length === 1;
}
